export const transferChoices = [
    { id: 1, name: "Working to Utility" },
    { id: 2, name: "Working to BulkPayment" },
    { id: 3, name: "Utility to Working" },
    { id: 4, name: "Utility to BulkPayment" },
    { id: 5, name: "BulkPayment to Working" },
    { id: 6, name: "BulkPayment to Utility" },
]
